import { FC, HTMLAttributes } from "react";
import Badge from "components-new/Badge";
import cn from "classnames";
import styles from "./Step.module.sass";

export enum STEP_STATUS {
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETE = "COMPLETE",
	NOT_STARTED = "NOT_STARTED",
}

interface StepProps extends HTMLAttributes<HTMLDivElement> {
	stepNumber: number;
	status: STEP_STATUS;
	accept: boolean;
}

const badgeColors = {
	NOT_STARTED: "#DD0B24",
	IN_PROGRESS: "#EA8F06",
	COMPLETE: "#35A440",
};
const Step: FC<StepProps> = ({ status, accept, stepNumber, children }) => {
	const whatStatus = (status: STEP_STATUS) => {
		switch (status) {
			case STEP_STATUS.COMPLETE:
				return "Завершён";

			case STEP_STATUS.IN_PROGRESS:
				return "В работе";

			case STEP_STATUS.NOT_STARTED:
				return "Не начато";

			default:
				return "Получение статуса";
		}
	};
	return (
		<div
			className={cn(
				styles.step,
				accept
					? {
							[styles.completed]: status === STEP_STATUS.COMPLETE,
							[styles.in_work]: status === STEP_STATUS.IN_PROGRESS,
							[styles.not_started]: status === STEP_STATUS.NOT_STARTED,
					  }
					: styles.empty,
			)}>
			<div className={styles.header}>
				<span className={styles.stepNumber}>Шаг {stepNumber}</span>
				{accept && <Badge color={badgeColors[status as keyof typeof badgeColors]}>{whatStatus(status)}</Badge>}
			</div>

			<div className={styles.main}>{children}</div>
		</div>
	);
};

export default Step;
